import fhirpath from 'fhirpath';
import { supportingInfoFhirPath } from './supportingInfo';

type MedicationOverrides = Partial<
  Omit<fhir4.Medication, 'id' | 'resourceType'>
>;

type MedicationDefaults = Partial<Omit<fhir4.Medication, 'resourceType'>>;

export const medicationReferenceFHIRPath = `MedicationRequest
    .contained
    .ofType(Medication)
    .where(id=%context.medicationReference.reference.substring(1))`;

export function requestAllowSubstitution(
  request: fhir4.MedicationRequest,
): boolean {
  const {
    substitution: { allowedBoolean: allowedSubstitution = false } = {},
  } = request;

  return allowedSubstitution;
}

export function medicationRequestTitle(
  request: fhir4.MedicationRequest,
): string {
  const candidates = [];
  const codeableConceptDisplay = `select(text | coding.display).first()`;

  const medicationCodePath = `MedicationRequest.medicationCodeableConcept`;
  const medicationCompoundedCodePath = `${medicationReferenceFHIRPath}.code`;
  const activeSubstitutionCodePath = `${supportingInfoFhirPath}.medicationCodeableConcept`;

  if (requestAllowSubstitution(request)) {
    candidates.push(activeSubstitutionCodePath);
  }

  candidates.push(medicationCodePath);
  candidates.push(medicationCompoundedCodePath);

  const titleFHIRPath = candidates
    .map(pathPrefix => `${pathPrefix}.${codeableConceptDisplay}`)
    .join(' | ');

  return fhirpath.evaluate(request, titleFHIRPath)[0];
}

export function updateOrCreateMedicationReference(
  request: fhir4.MedicationRequest,
  data: MedicationOverrides,
  defaults: MedicationDefaults = { id: 'medication-reference' },
): fhir4.MedicationRequest {
  const { contained = [], medicationReference, ...medicationRequest } = {
    ...request,
  };

  let medication: fhir4.Medication | null = null;
  let medicationContained: fhir4.FhirResource[] = [];

  if (medicationReference) {
    medicationContained = contained.map(inner => {
      if (
        inner.resourceType === 'Medication' &&
        inner.id === medicationReference.reference?.substring(1)
      ) {
        medication = { ...inner, ...data };
        return medication;
      }

      return inner;
    });
  }

  if (medication === null) {
    medication = {
      resourceType: 'Medication',
      ...defaults,
      ...data,
    };

    medicationContained.push(medication);
  }

  return {
    ...medicationRequest,
    contained: medicationContained,
    medicationReference: { reference: `#${medication.id}` },
  };
}
